"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.default = exports.PureOffer = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _CouponInput = _interopRequireDefault(require("../../containers/CouponInput/CouponInput.container"));
var _Input = require("../Input");
var _Payment = _interopRequireDefault(require("../Payment"));
var _Header = _interopRequireDefault(require("../Header"));
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _CheckoutPriceBox = _interopRequireDefault(require("../CheckoutPriceBox"));
var _FreeOffer = _interopRequireDefault(require("../FreeOffer"));
var _OfferStyled = require("./OfferStyled");
var _OfferCheckoutCard = _interopRequireDefault(require("../OfferCheckoutCard"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Offer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Offer, _Component);
  var _super = _createSuper(Offer);
  function Offer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Offer);
    _this = _super.call(this, props);
    _this.state = {
      coupon: ''
    };
    return _this;
  }
  (0, _createClass2.default)(Offer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        trialAvailable = _this$props.trialAvailable,
        discountApplied = _this$props.discountApplied,
        totalPrice = _this$props.totalPrice,
        onSubmit = _this$props.couponProps.onSubmit,
        onPaymentComplete = _this$props.onPaymentComplete,
        t = _this$props.t;
      var coupon = this.state.coupon;
      var isFree = totalPrice === 0 && !trialAvailable && !discountApplied;
      if (isFree) {
        return /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement("main", null, /*#__PURE__*/_react.default.createElement(_FreeOffer.default, {
          onPaymentComplete: onPaymentComplete
        })));
      }
      return /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement("main", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferBody, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
        center: true
      }, t('Complete your purchase')), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferDetailsAndCoupon, null, /*#__PURE__*/_react.default.createElement(_OfferStyled.OfferCardWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_OfferCheckoutCard.default, null)), /*#__PURE__*/_react.default.createElement(_OfferStyled.StyledOfferCouponWrapper, null, /*#__PURE__*/_react.default.createElement(_CouponInput.default, {
        onSubmit: onSubmit,
        value: coupon,
        onChange: function onChange(e) {
          return _this2.setState({
            coupon: e
          });
        },
        source: "checkout"
      })))), /*#__PURE__*/_react.default.createElement(_CheckoutPriceBox.default, null)), /*#__PURE__*/_react.default.createElement(_Payment.default, {
        onPaymentComplete: onPaymentComplete
      }))), /*#__PURE__*/_react.default.createElement(_Footer.default, null));
    }
  }]);
  return Offer;
}(_react.Component);
exports.PureOffer = Offer;
Offer.propTypes = {
  trialAvailable: _propTypes.default.bool.isRequired,
  totalPrice: _propTypes.default.number.isRequired,
  discountApplied: _propTypes.default.bool.isRequired,
  couponProps: _propTypes.default.shape({
    showMessage: _propTypes.default.bool,
    message: _propTypes.default.node,
    messageType: _propTypes.default.oneOf([_Input.MESSAGE_TYPE_FAIL, _Input.MESSAGE_TYPE_SUCCESS]),
    onSubmit: _propTypes.default.func.isRequired,
    couponLoading: _propTypes.default.bool
  }),
  onPaymentComplete: _propTypes.default.func.isRequired,
  t: _propTypes.default.func
};
Offer.defaultProps = {
  couponProps: null,
  t: function t(k) {
    return k;
  }
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    trialAvailable: state.offer.offer.trialAvailable,
    totalPrice: state.order.order.totalPrice,
    discountApplied: state.order.order.discount.applied
  };
};
exports.mapStateToProps = mapStateToProps;
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()((0, _reactRedux.connect)(mapStateToProps)(Offer))); // export default Offer;
exports.default = _default;